import React from 'react';

import style from "./style.scss";
import classNames from "classnames/bind";
import stylingUtils from "../../services/stylingUtilities";

class FancyCheckbox extends React.Component {

    _getClassNames() {

        var cx = classNames.bind(style);

        var baseStyle = {
            'checkbox': true
        };

        return cx(stylingUtils.mergeClassNames(baseStyle, this.props.className));
    }

    render() {
        return (
            <div className={this._getClassNames()}>
                <input
                    {...this.props}
                    type={this.props.type}
                    id={'checkbox_' + this.props.id}
                    onClick={this.props.onClick}
                    checked={this.props.checked}
                />
                <label htmlFor={'checkbox_' + this.props.id}></label>
            </div>
        );
    }
}

FancyCheckbox.defaultProps = {
    id: Math.random(),
    type: 'checkbox',
    onClick: () => {},
    checked: false
};

export default FancyCheckbox;


// WEBPACK FOOTER //
// ./components/FancyCheckbox/index.js